import * as Colors from 'src/theme/colors';

export default {
  tooltip: {
    backgroundColor: Colors.BlackHeadings,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  },
};
